'use client';
import Image from 'next/image';
import React from 'react';
import MetaTags from '@/components/meta-tag/meta-tag';

const Page = () => {
    return (
        <>
            <MetaTags />
            <section>
                <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                    <div className="container lg:container md:mx-auto">
                        <div className="row grid md:grid-cols-12 lg:grid-cols-12 bg-white rounded-10">
                            <div className="md:col-span-10 lg:col-span-10 xl:col-span-6 xl:col-start-4 lg:col-start-2 md:col-start-2 py-100 text-center mx-2">
                                <div>
                                    <Image
                                        src="/img/thank-you@2x.webp"
                                        alt="thank you"
                                        title="thank you"
                                        height="295"
                                        width="398"
                                        loading="lazy"
                                        data-aos="fade-up"
                                        data-aos-duration={1000}
                                        data-aos-delay={100}
                                        className="mb-50 img-fluid"
                                    />
                                    <h1 className="fs-xl fw-600 mb-2.5"> Thank you for Contacting Us</h1>
                                    <p className="mb-0 text-textcolor">
                                        One of us will review your enquiry and will get back to you soon.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Page;
